import { Injectable } from '@angular/core';
import { PBConfigItem } from '../interfaces/presentation-builder-config.model';

/** Responsible for converting a form config into presentation builder items  */
@Injectable()
export abstract class PresentationBuilderAdapter<S, T> {
  abstract read(data: S): PBConfigItem<T>[];
}
